import React, { useEffect, useRef, useState } from 'react';
import { sliderApi } from '../api/sliderApi';

const MainSlider = () => {
  const sliderInitialized = useRef(false);
  
  // Fallback slider data
  const fallbackSliders = [
    {
      _id: 'fallback-1',
      title: 'Welcome to <span>Our Platform</span>',
      subtitle: 'Discover amazing opportunities and connect with innovation',
      image: '/img/slider/2.jpg',
      alignment: 'left',
      isActive: true,
      priority: 1
    },
    {
      _id: 'fallback-2',
      title: 'Building the <span>Future Together</span>',
      subtitle: 'Empowering growth through collaboration and innovation',
      image: '/img/slider/3.jpg',
      alignment: 'center',
      isActive: true,
      priority: 2
    },
    {
      _id: 'fallback-3',
      title: 'Your Success is <span>Our Mission</span>',
      subtitle: 'Join us in creating transformative solutions',
      image: '/img/slider/4.jpg',
      alignment: 'right',
      isActive: true,
      priority: 3
    }
  ];
  
  const [sliders, setSliders] = useState(fallbackSliders);
  const [loading, setLoading] = useState(true);

  // Fetch sliders from API
  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await sliderApi.getPublicSliders();
        if (response.success && response.data && response.data.length > 0) {
          setSliders(response.data);
        } else {
          // Keep fallback sliders if no data
          setSliders(fallbackSliders);
        }
      } catch (error) {
        console.error('Error fetching sliders:', error);
        // Keep fallback sliders on error
        setSliders(fallbackSliders);
      } finally {
        setLoading(false);
      }
    };

    fetchSliders();
  }, []);

  useEffect(() => {
    // Don't initialize slider until we have data
    if (loading || sliders.length === 0) return;

    // Function to initialize the slider
    const initSlider = () => {
      if (window.jQuery && window.jQuery.fn.revolution) {
        const $ = window.jQuery;
        const sliderElement = $('#rev_slider_one');
        
        // Check if slider exists and is visible
        if (sliderElement.length > 0) {
          try {
            // Destroy existing instance if any
            if (sliderElement.data('revslider-initialised')) {
              sliderElement.revkill();
            }
            
            // Initialize new instance
            sliderElement.show().revolution({
              sliderType: "standard",
              sliderLayout: "fullwidth",
              delay: 9000,
              navigation: {
                arrows: {
                  enable: true,
                  style: "gyges",
                  hide_onmobile: true,
                  hide_under: 600,
                  hide_onleave: true,
                  left: {
                    h_align: "left",
                    v_align: "center",
                    h_offset: 30,
                    v_offset: 0
                  },
                  right: {
                    h_align: "right",
                    v_align: "center",
                    h_offset: 30,
                    v_offset: 0
                  }
                },
                bullets: {
                  enable: true,
                  hide_onmobile: true,
                  hide_under: 600,
                  style: "metis",
                  hide_onleave: true,
                  direction: "horizontal",
                  h_align: "center",
                  v_align: "bottom",
                  h_offset: 0,
                  v_offset: 30,
                  space: 5
                }
              },
              gridwidth: [1240, 1024, 778, 480],
              gridheight: [700, 600, 600, 600],
              lazyType: "none",
              parallax: {
                type: "scroll",
                levels: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50]
              },
              spinner: "off",
              autoHeight: "off",
              disableProgressBar: "on",
              hideThumbsOnMobile: "off",
              hideSliderAtLimit: 0,
              hideCaptionAtLimit: 0,
              hideAllCaptionAtLilmit: 0,
              debugMode: false
            });
            
            sliderInitialized.current = true;
          } catch (error) {
            console.error('Error initializing Revolution Slider:', error);
          }
        }
      }
    };

    // Wait a bit for DOM to be ready and scripts to load
    const timer = setTimeout(() => {
      initSlider();
    }, 100);

    // Cleanup function
    return () => {
      clearTimeout(timer);
      if (window.jQuery && window.jQuery.fn.revolution) {
        const $ = window.jQuery;
        const sliderElement = $('#rev_slider_one');
        if (sliderElement.length > 0 && sliderInitialized.current) {
          try {
            sliderElement.revkill();
          } catch (e) {
            //console.log('Slider cleanup:', e);
          }
        }
      }
      sliderInitialized.current = false;
    };
  }, [loading, sliders]); // Re-run when sliders data changes

  // Helper function to parse title with span tags
  const parseTitle = (title) => {
    if (!title) return '';
    const parts = title.split(/(<span>.*?<\/span>)/g);
    return parts.map((part, index) => {
      if (part.startsWith('<span>') && part.endsWith('</span>')) {
        const content = part.replace('<span>', '').replace('</span>', '');
        return <span key={index}>{content}</span>;
      }
      return part;
    });
  };

  if (loading) {
    return (
      <section className="main-slider" style={{ minHeight: '700px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600"></div>
      </section>
    );
  }

  // No need to check for empty sliders since we always have fallback data

  return (
    <section className="main-slider">
      <div className="rev_slider_wrapper fullwidthbanner-container" id="rev_slider_one_wrapper" data-source="gallery">
        <div className="rev_slider fullwidthabanner" id="rev_slider_one" data-version="5.4.1">
          <ul>
            {sliders.map((slider, index) => (
              <li 
                key={slider._id}
                className={`slide-${index + 1}`}
                data-description="Slide Description" 
                data-easein="default" 
                data-easeout="default" 
                data-fsmasterspeed="1500" 
                data-fsslotamount="7" 
                data-fstransition="slotzoom-horizontal" 
                data-hideafterloop="0" 
                data-hideslideonmobile="off" 
                data-index={`rs-${1687 + index}`}
                data-masterspeed="default" 
                data-param1="" 
                data-param10="" 
                data-param2="" 
                data-param3="" 
                data-param4="" 
                data-param5="" 
                data-param6="" 
                data-param7="" 
                data-param8="" 
                data-param9="" 
                data-rotate="0" 
                data-saveperformance="off" 
                data-slotamount="default" 
                data-thumb={slider.image}
                data-title={slider.title}
                data-transition="parallaxvertical"
              >
                <img 
                  alt={slider.title}
                  className="rev-slidebg" 
                  data-bgfit="cover" 
                  data-bgparallax="10" 
                  data-bgposition="center center" 
                  data-bgrepeat="no-repeat" 
                  data-no-retina="" 
                  src={slider.image}
                /> 
                
                <div 
                  className="tp-caption"
                  data-paddingbottom="[0,0,0,0]"
                  data-paddingleft="[0,0,0,0]"
                  data-paddingright="[0,0,0,0]"
                  data-paddingtop="[0,0,0,0]"
                  data-responsive_offset="on"
                  data-type="text"
                  data-height="none"
                  data-width="['650','750','700','420']"
                  data-whitespace="normal"
                  data-hoffset="['15','15','15','15']"
                  data-voffset="['-90','-80','-10','20']"
                  data-x={`['${slider.alignment}','${slider.alignment}','${slider.alignment}','${slider.alignment}']`}
                  data-y="['middle','middle','middle','middle']"
                  data-textalign="['top','top','top','top']"
                  data-frames='[{"from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","speed":1500,"to":"o:1;","delay":1000,"ease":"Power3.easeInOut"},{"delay":"wait","speed":1000,"to":"auto:auto;","mask":"x:0;y:0;s:inherit;e:inherit;","ease":"Power3.easeInOut"}]'
                  style={{zIndex: 7, whiteSpace: 'nowrap', textAlign: slider.alignment}}
                >
                  <h2 dangerouslySetInnerHTML={{ __html: slider.title }}></h2>
                </div>
                
                {slider.subtitle && (
                  <div 
                    className="tp-caption tp-resizeme" 
                    data-paddingbottom="[0,0,0,0]"
                    data-paddingleft="[0,0,0,0]"
                    data-paddingright="[0,0,0,0]"
                    data-paddingtop="[0,0,0,0]"
                    data-responsive_offset="on"
                    data-type="text"
                    data-height="none"
                    data-width="['550','600','650','420']"
                    data-whitespace="normal"
                    data-hoffset="['15','15','15','15']"
                    data-voffset="['50','40','105','95']"
                    data-x={`['${slider.alignment}','${slider.alignment}','${slider.alignment}','${slider.alignment}']`}
                    data-y="['middle','middle','middle','middle']"
                    data-textalign="['top','top','top','top']"
                    data-frames='[{"from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","speed":1500,"to":"o:1;","delay":1000,"ease":"Power3.easeInOut"},{"delay":"wait","speed":1000,"to":"auto:auto;","mask":"x:0;y:0;s:inherit;e:inherit;","ease":"Power3.easeInOut"}]'
                    style={{zIndex: 7, whiteSpace: 'nowrap', textAlign: slider.alignment}}
                  >
                    <p>{slider.subtitle}</p>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default MainSlider;


